// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import type { Environment } from './environment.interface';

export const env: Environment = {
  production: true,
  name: 'Staging',
  webSocketURL: 'wss://ws.fantazstaging-dev.com',
  baseURL: 'https://www.fantazstaging-dev.com',
  CognitoUrl: 'https://auth.fantazstaging-dev.com',
  gameFileHost: 'https://www.fantazstaging-dev.com/games-store/',
  apiBaseUrl: 'https://www.fantazstaging-dev.com',
  UPLOAD_CUSTOMER_CARD: false,
  devToolDetection: false,
  zendeskDomain: 'fantaz1657920777.zendesk.com',
  showScoresWhileTournamentIsInProgress: false,
  smartLookIntegrationScript: `
  window.smartlook ||
  (function (d) {
    var o = (smartlook = function () {
      o.api.push(arguments);
    }),
    h = d.getElementsByTagName('head')[0];
    var c = d.createElement('script');
    o.api = new Array();
    c.async = true;
    c.type = 'text/javascript';
    c.charset = 'utf-8';
    c.src = 'https://web-sdk.smartlook.com/recorder.js';
    h.appendChild(c);
  })(document);
  smartlook('init', '2350859013e556706bb3199b557dc61d1db4a33f', {
    region: 'us',
  });
  `,
  autocomplete: {
    enabled: true,
    provider: 'google',
    config: {
      google: {
        apiKey: 'AIzaSyCkgdtqamsB_VnRsr1xP86RHOB0Zhn6JwA',
      },
      smarty: {
        apiKey: '171091271069604852',
      },
    },
  },
  gtmConfig: {
    GTM_ID: 'GTM-T7W9QJV',
    GTM_AUTH: 'FOyPTvXzAB--BZzFcgLgjA',
    GTM_PREVIEW: 'env-11',
  },
  tsevoConfig: {
    SSN_ALLOWED: true,
    FULL_SSN_ALLOWED: true,
    apiUrl: 'https://api.gidx-service.in/v3.0/api/',
  },
  Auth: {
    identityPoolId: 'us-east-1:f754e2e1-c0d1-456f-b135-fe4c41e6a283',
    region: 'us-east-1',
    userPoolId: 'us-east-1_fOU939bIb',
    userPoolWebClientId: '1daifg2jatjftk654lfs7nonvn',
    mandatorySignIn: true,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    oauth: {
      domain: 'auth.fantazstaging-dev.com',
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://www.fantazstaging-dev.com/auth/federated-signin',
      redirectSignOut: 'https://www.fantazstaging-dev.com',
      responseType: 'code',
    },
  },
  notifications: {
    NovuApplicationIdentifier: 'rjBX1Dt-wM99',
  },
  fBApi: {
    fbApiKey: '875919356515632',
    xfbml: true,
    version: 'v2.10',
  },
  reCaptcha: {
    siteKeyV3: '6LcVD8YpAAAAADbxOKUJ0RdrpIMGincMMwKM61yM',
    siteKeyV2: '6Lc6CsgpAAAAADaPYlczu0bx_alkAly_aBv26hrx',
  },
  cognitoAdvancedSecurity: false,
  posthog: {
    apiKey: 'phc_5DGMQD7JTmImUOncuBZ71dLUfDHxuF4jMj0fohF9UVP',
    host: 'https://us.i.posthog.com',
  },
};

export const environment = env;
